"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatBrandName = void 0;
const React = require("react");
const styles = require("./SinglePaymentOption.styles.scss");
const PaymentIcon_1 = require("./PaymentIcon");
const md_1 = require("react-icons/md");
const FlatButton_1 = require("./FlatButton");
const BRAND_MAPPING = {
    amex: "American Express",
    cartes_bancaires: "Cartes Bancaires",
    diners_club: "Diners Club",
    discover: "Discover",
    eftpos_australia: "EFTPOS Australia",
    interac: "Interac",
    jcb: "JCB",
    mastercard: "Mastercard",
    union_pay: "UnionPay",
    // visa: "American Express",
    visa: "Visa",
    other: "Other"
};
const formatBrandName = (brand) => {
    const normalizedBrand = brand.toLowerCase();
    if (BRAND_MAPPING.hasOwnProperty(normalizedBrand)) {
        return BRAND_MAPPING[normalizedBrand];
    }
    else {
        return brand.replace(/\b\w/g, char => char.toUpperCase());
    }
};
exports.formatBrandName = formatBrandName;
const SinglePaymentOption = ({ icon, description, name, onSelect, onDelete }) => {
    var _a;
    let brandName = (0, exports.formatBrandName)(name);
    let iconName = (_a = icon) !== null && _a !== void 0 ? _a : "creditCard";
    return (React.createElement("div", { onClick: onSelect, className: `${styles.mainFonts} ${styles.singlePaymentContainer}` },
        React.createElement("div", { className: styles.paymentIconContainer },
            React.createElement(PaymentIcon_1.default, { type: iconName }),
            description && (React.createElement("div", { style: { fontSize: 10, color: "#959595" } }, description))),
        React.createElement("div", null),
        React.createElement("div", { className: styles.brandName },
            React.createElement("div", { style: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                } }, brandName)),
        React.createElement("div", { className: styles.sideArrow }, onDelete && (React.createElement(FlatButton_1.default, { onClick: e => {
                e.stopPropagation();
                onDelete();
            }, style: { padding: 0, backgroundColor: "#fe6e6e" } },
            React.createElement("div", { style: {
                    display: "flex",
                    justifyContent: "center",
                    padding: 5
                } },
                React.createElement(md_1.MdDeleteForever, null)))))));
};
exports.default = SinglePaymentOption;
//# sourceMappingURL=SinglePaymentOption.js.map